export const PAYMENTS_DISABLED = true;

export const PAYMENTS_DISABLED_MESSAGE =
  'Llambada is not accepting payments or subscription changes at this time.';
